import { Loader2 } from "lucide-react";
import type { Dispatch, SetStateAction } from "react";
import { useI18n } from "@/locales/client";
import { ResponsiveModal } from "../responsive-modal";
import { Button } from "../ui/button";

type Props = {
  title: string;
  message: string;
  handleCancel: () => void;
  handleConfirm: () => void;
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  pending: boolean;
};

export const DeleteModal = ({
  title,
  message,
  handleCancel,
  handleConfirm,
  isOpen,
  setIsOpen,
  pending,
}: Props) => {
  const t = useI18n();
  return (
    <ResponsiveModal
      title={title}
      description={message}
      open={isOpen}
      onOpenChange={setIsOpen}
      form={
        <div className="flex flex-col-reverse gap-y-2 md:gap-y-0 md:flex-row w-full md:items-center md:justify-between">
          {" "}
          <Button variant="outline" onClick={handleCancel}>
            {t("deleteModal.cancel")}
          </Button>
          <Button
            variant={"destructive"}
            className="flex gap-x-2"
            onClick={handleConfirm}
          >
            {pending && <Loader2 className="h-4 w-4 animate-spin" />}
            {pending ? t("deleteModal.confirming") : t("deleteModal.confirm")}
          </Button>
        </div>
      }
    />
    //   <AlertDialog open={isOpen}>
    //     <AlertDialogContent>
    //       <AlertDialogHeader>
    //         <AlertDialogTitle>{title}</AlertDialogTitle>
    //         <AlertDialogDescription>{message}</AlertDialogDescription>
    //       </AlertDialogHeader>
    //       <AlertDialogFooter className="flex justify-end gap-x-2">
    //         <Button variant="outline" onClick={handleCancel}>
    //           Cancel
    //         </Button>
    //         <AlertDialogAction
    //           className="bg-destructive flex gap-x-2"
    //           onClick={handleConfirm}
    //         >
    //           {pending && <Loader2 className="h-4 w-4 animate-spin" />}
    //           {pending ? "Confirming" : "Confirm"}
    //         </AlertDialogAction>
    //       </AlertDialogFooter>
    //     </AlertDialogContent>
    //   </AlertDialog>
    // );
  );
};
